const NO_VALUE = '–'

export function formatCount(value: number, locale: string): string {
  return new Intl.NumberFormat(locale).format(value)
}

export function formatShare(share: number | null, locale: string): string {
  if (share === null) return NO_VALUE
  return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 0 }).format(share)
}

export function formatAverage(value: number | null, locale: string): string {
  if (value === null) return NO_VALUE
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(value)
}

export function withDayLabels<T extends { day: string }>(
  daily: readonly T[],
  locale: string,
): (T & { label: string })[] {
  const format = new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
  })
  return daily.map((entry) => ({
    ...entry,
    label: format.format(new Date(`${entry.day}T00:00:00Z`)),
  }))
}

export function formatSnapshotTime(generatedAt: string, locale: string): string {
  return new Date(generatedAt).toLocaleString(locale, { dateStyle: 'medium', timeStyle: 'short' })
}

export function oldestSnapshot(generatedAt: readonly (string | undefined)[]): string | undefined {
  let oldest: string | undefined
  for (const value of generatedAt) {
    if (value !== undefined && (oldest === undefined || Date.parse(value) < Date.parse(oldest))) {
      oldest = value
    }
  }
  return oldest
}
